/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { ExceptionData } from './ExceptionData';
import {
    ExceptionDataFromJSON,
    ExceptionDataFromJSONTyped,
    ExceptionDataToJSON,
} from './ExceptionData';
import type { I18nInfo } from './I18nInfo';
import {
    I18nInfoFromJSON,
    I18nInfoFromJSONTyped,
    I18nInfoToJSON,
} from './I18nInfo';
import type { Exception } from './Exception';
import {
    ExceptionFromJSON,
    ExceptionFromJSONTyped,
    ExceptionToJSON,
} from './Exception';

/**
 * 
 * @export
 * @interface Ptw100NotFoundException
 */
export interface Ptw100NotFoundException {
    /**
     * 
     * @type {string}
     * @memberof Ptw100NotFoundException
     */
    readonly targetSite?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Ptw100NotFoundException
     */
    readonly message?: string | null;
    /**
     * 
     * @type {ExceptionData}
     * @memberof Ptw100NotFoundException
     */
    data?: ExceptionData | null;
    /**
     * 
     * @type {Exception}
     * @memberof Ptw100NotFoundException
     */
    innerException?: Exception;
    /**
     * 
     * @type {string}
     * @memberof Ptw100NotFoundException
     */
    helpLink?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Ptw100NotFoundException
     */
    source?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Ptw100NotFoundException
     */
    hResult?: number;
    /**
     * 
     * @type {string}
     * @memberof Ptw100NotFoundException
     */
    readonly stackTrace?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Ptw100NotFoundException
     */
    code?: number;
    /**
     * 
     * @type {I18nInfo}
     * @memberof Ptw100NotFoundException
     */
    i18n?: I18nInfo;
    /**
     * 
     * @type {string}
     * @memberof Ptw100NotFoundException
     */
    $type?: Ptw100NotFoundExceptionTypeEnum;
}


/**
 * @export
 */
export const Ptw100NotFoundExceptionTypeEnum = {
    PtwPtw100AppZeroCoreSharedExceptionsPtw100NotFoundExceptionPtwPtw100AppZeroCoreShared: 'Ptw.Ptw100.AppZero.Core.Shared.Exceptions.Ptw100NotFoundException, Ptw.Ptw100.AppZero.Core.Shared'
} as const;
export type Ptw100NotFoundExceptionTypeEnum = typeof Ptw100NotFoundExceptionTypeEnum[keyof typeof Ptw100NotFoundExceptionTypeEnum];



/**
 * Check if a given object implements the Ptw100NotFoundException interface.
 */
export function instanceOfPtw100NotFoundException(value?: unknown): value is Ptw100NotFoundException {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(Ptw100NotFoundExceptionTypeEnum)[0];
}

export function Ptw100NotFoundExceptionFromJSON(json: any): Ptw100NotFoundException {
    return Ptw100NotFoundExceptionFromJSONTyped(json, false);
}

export function Ptw100NotFoundExceptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Ptw100NotFoundException {
    if (json == null) {
        return json;
    }
    return {
        
        'targetSite': json['targetSite'] == null ? undefined : json['targetSite'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ExceptionDataFromJSON(json['data']),
        'innerException': json['innerException'] == null ? undefined : ExceptionFromJSON(json['innerException']),
        'helpLink': json['helpLink'] == null ? undefined : json['helpLink'],
        'source': json['source'] == null ? undefined : json['source'],
        'hResult': json['hResult'] == null ? undefined : json['hResult'],
        'stackTrace': json['stackTrace'] == null ? undefined : json['stackTrace'],
        'code': json['code'] == null ? undefined : json['code'],
        'i18n': json['i18n'] == null ? undefined : I18nInfoFromJSON(json['i18n']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function Ptw100NotFoundExceptionToJSON(value?: Omit<Ptw100NotFoundException, 'targetSite'|'message'|'stackTrace'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'data': ExceptionDataToJSON(value['data']),
        'innerException': ExceptionToJSON(value['innerException']),
        'helpLink': value['helpLink'],
        'source': value['source'],
        'hResult': value['hResult'],
        'code': value['code'],
        'i18n': I18nInfoToJSON(value['i18n']),
        '$type': value['$type'],
    });
}

